function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  className: "iconic-metadata"
}, /*#__PURE__*/React.createElement("title", null, "Info"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  className: "iconic-container",
  "data-width": 10,
  "data-height": 32,
  transform: "translate(11)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 7.5,
  cy: 2.5,
  r: 2.5,
  className: "iconic-info-dot iconic-property-fill"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 28c0 2.209 1.791 4 4 4s4-1.791 4-4v-1h-1v1c0 .828-.672 1.5-1.5 1.5s-1.5-.672-1.5-1.5 4-15 4-17-1.791-4-4-4-4 1.791-4 4v1h1v-1c0-.828.672-1.5 1.5-1.5s1.5.792 1.5 1.5-4 14.791-4 17z",
  className: "iconic-info-vertical-line iconic-property-fill"
}));

function SvgInfoMd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    "data-icon": "info",
    className: "iconic iconic-info iconic-size-md",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoMd);
export default __webpack_public_path__ + "static/media/info-md.7ecf1f35.svg";
export { ForwardRef as ReactComponent };